<template>
	<div class="modal fade" :id="modal_id" tabindex="-1" role="dialog" aria-labelledby="TituloModalCentralizado" aria-hidden="true">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <div class="modal-header">
	        <h5 class="modal-title" id="TituloModalCentralizado">{{ title }}</h5>
	        <button type="button" class="close" data-dismiss="modal" aria-label="Fechar">
	          <span aria-hidden="true">&times;</span>
	        </button>
	      </div>
	      <div class="modal-body" v-if="message">
	      		{{ message }}
	      </div>
	      <div class="modal-footer">
	        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
	        <button type="button" class="btn" :class="btnStyle" data-dismiss="modal" @click="action()">{{ btn }}</button>
	      </div>
	    </div>
	  </div>
	</div>
</template>
 
<script>
	export default {
		props : { 
			modal_id: {
				default: 'confirm_modal'
			},
			title:{},
			message:{},  
			btn: {
				default: 'Excluir'
			}, 
			btnStyle: {
				default: 'btn-primary'
			}
		},

		methods : {
			action(){
				this.$emit('action');
			}
		}
	}
</script>